// Extracted from legacy src/components/templates.js

export const COMPONENTS = {
  hero: {
    render: (props) => ({
      type: 'hero',
      props: {
        height: props.height || 'fullscreen',
        imagePosition: props.imagePosition || 'background',
        title: props.title || '',
        subtitle: props.subtitle || '',
        image: props.image || '',
        ctaText: props.ctaText || '',
        ctaLink: props.ctaLink || ''
      }
    }),
    defaultProps: {
      height: 'fullscreen',
      imagePosition: 'background',
      title: 'Вашата история',
      subtitle: 'Добавете дата, място или кратко послание',
      image: '',
      ctaText: '',
      ctaLink: ''
    },
    controls: ['title', 'subtitle', 'image', 'ctaText', 'ctaLink', 'height', 'imagePosition', 'alignment']
  },
  gallery: {
    render: (props) => ({
      type: 'gallery',
      props: {
        layout: props.layout || 'grid',
        columns: props.columns || 3,
        images: props.images || [],
        spacing: props.spacing || 'medium',
        captions: props.captions || false
      }
    }),
    defaultProps: {
      layout: 'grid',
      columns: 3,
      images: [],
      spacing: 'medium',
      captions: false
    },
    controls: ['images', 'layout', 'columns', 'spacing', 'captions']
  },
  text: {
    render: (props) => ({
      type: 'text',
      props: {
        content: props.content || '',
        alignment: props.alignment || 'left',
        size: props.size || 'medium'
      }
    }),
    defaultProps: {
      content: 'Enter your text here',
      alignment: 'left',
      size: 'medium'
    },
    controls: ['content', 'alignment', 'size']
  },
  timeline: {
    render: (props) => ({
      type: 'timeline',
      props: {
        events: props.events || [],
        style: props.style || 'elegant',
        alignment: props.alignment || 'center'
      }
    }),
    defaultProps: {
      events: [
        {
          date: 'Началото',
          title: 'Първа среща',
          description: 'Разкажете къде започна вашата история.',
          image: 'https://images.unsplash.com/photo-1522673607200-164d1b6ce486?auto=format&fit=crop&w=800&q=80'
        },
        {
          date: 'Любим момент',
          title: 'Специален спомен',
          description: 'Добавете кратко описание на важен момент от връзката ви.',
          image: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=800&q=80'
        },
        {
          date: 'Завинаги',
          title: 'Предложението',
          description: 'Споделете момента, в който решихте да започнете новата глава заедно.',
          image: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&w=800&q=80'
        }
      ],
      style: 'elegant',
      alignment: 'center'
    },
    controls: ['events', 'style', 'alignment']
  },
  countdown: {
    render: (props) => ({
      type: 'countdown',
      props: {
        weddingDate: props.weddingDate || '',
        alignment: props.alignment || 'center'
      }
    }),
    defaultProps: {
      weddingDate: '2025-12-31T18:00:00',
      alignment: 'center'
    },
    controls: ['weddingDate', 'alignment']
  },
  emailForm: {
    type: 'emailForm',
    defaultProps: {
      title: 'Свържете се с нас',
      description: 'Изпратете ни съобщение и ние ще се свържем с вас възможно най-скоро.',
      style: 'standard',
      width: 'medium',
      backgroundColor: '#ffffff',
      textColor: '#333333',
      buttonColor: '#4e7c7f',
      buttonTextColor: '#ffffff'
    },
    defaultStyles: {
      backgroundColor: '#ffffff',
      padding: '2rem',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }
  },
  weddingPhotoGallery: {
    render: (props) => ({
      type: 'weddingPhotoGallery',
      props: {
        title: props.title || 'Wedding Gallery',
        description: props.description || 'Share your special moments with us',
        layout: props.layout || 'masonry',
        columns: props.columns || 3,
        photos: props.photos || [],
        allowUpload: props.allowUpload || true,
        uploadButtonText: props.uploadButtonText || 'Add Your Photo'
      }
    }),
    defaultProps: {
      title: 'Сватбена Галерия',
      description: 'Споделете вашите специални моменти с нас',
      layout: 'masonry',
      columns: 3,
      photos: [],
      allowUpload: true,
      uploadButtonText: 'Добавете снимка'
    },
    controls: ['title', 'description', 'layout', 'columns', 'photos', 'allowUpload', 'uploadButtonText']
  },
  bestMenAndMaids: {
    defaultProps: {
      title: 'Нашите Кумове',
      description: '',
      photoCount: 2,
      photos: []
    }
  }
};
